import api from "@/lib/api";

export function trackEvent(name, params = {}) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
    }
  } catch (_) { /* analytics must never break the app */ }
}

function visitorId() {
  let id = localStorage.getItem("uvg_vid");
  if (!id) {
    id = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("uvg_vid", id);
  }
  return id;
}

let lastTracked = "";

export function trackPageView(path) {
  if (path === lastTracked) return;
  lastTracked = path;
  const lang = localStorage.getItem("uvg_lang") || "en";
  api.post("/track", {
    path,
    visitor_id: visitorId(),
    lang,
    ref: document.referrer || "",
  }).catch(() => {});
}
